<mat-accordion>
	<mat-expansion-panel disabled="true" [expanded]="true" hideToggle="true">
		<mat-expansion-panel-header>
			<mat-panel-title>
				<mat-icon color="primary">email</mat-icon>
				<span style="font-size: 20px"><b>Email</b></span>
			</mat-panel-title>
			<mat-panel-description>
				<button *ngIf="!readOnly" mat-raised-button color="primary" class="button-add-row" (click)="addRow()">
					Add Email
				</button>

			</mat-panel-description>
		</mat-expansion-panel-header>
		<table mat-table [dataSource]="dataSource" *ngIf="dataSource.data.length>0">
			<ng-container [matColumnDef]="col.key" *ngFor="let col of columnsSchema">
				<th mat-header-cell *matHeaderCellDef>
					<h4>{{ col.label }}</h4>
				</th>
				<td style="padding-top: 20px" mat-cell *matCellDef="let element" [ngClass]="{'past-row':  !isRowEditable(element)}">
					<div [ngSwitch]="col.key" *ngIf="!element.isEdit">
						<div *ngSwitchCase="'isEdit'" class="btn-edit">
							<div *ngIf="isRowEditable(element)">
								<button *ngIf="!readOnly" mat-icon-button color="primary" (click)="editRow(element)">
									<mat-icon>edit</mat-icon>
								</button>
								<button *ngIf="!readOnly" mat-icon-button color="warn"
									(click)="removeRow(element.partyContactMechanisms.ID)">
									<mat-icon>delete</mat-icon>
								</button>
							</div>
							<div *ngIf="!isRowEditable(element)" style="color:red">
								Past Email
							</div>
						</div>
						<span *ngSwitchCase="'activeDate'">
							{{ element.partyContactMechanisms?.CREATED_DATE | simpleDate }}
						</span>
						<span *ngSwitchCase="'emailType'">
							{{element.partyContactMechanisms.PARTY_CONTACT_MECHANISM_PURPOSES
							?
							element.partyContactMechanisms.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE
							: ''
							}}
						</span>
						<span *ngSwitchCase="'email'">
							{{element.partyContactMechanisms.CONTACT_MECHANISMS!.EMAILS![0].EMAIL_ADDRESS }}
						</span>
					</div>

					<div [ngSwitch]="col.key" *ngIf="element.isEdit">
						<div *ngSwitchCase="'activeDate'">
							{{ element.partyContactMechanisms.CREATED_DATE | simpleDate }}
						</div>
						<mat-form-field *ngSwitchCase="'emailType'" class="form-input" style="width:100%"
							appearance="fill">
							<mat-label>Email Type</mat-label>
							<mat-select
								[(ngModel)]="element.partyContactMechanisms.PARTY_CONTACT_MECHANISM_PURPOSES?.[0].CONTACT_MECHANISM_PURPOSE_TYPES"
								[compareWith]="compareFn" required="true">
								<mat-option *ngFor="let type of contactMechanismPurposeTypes " [value]="type">
									{{type.TYPE}}
								</mat-option>
							</mat-select>
						</mat-form-field>

						<div *ngSwitchCase="'email'" class="row">
							<div class="col">
								<mat-form-field>
									<mat-label>Email</mat-label>
									<input matInput [formControl]="email" placeholder="Valid Email Address"
										[(ngModel)]="element.partyContactMechanisms.CONTACT_MECHANISMS.EMAILS[0].EMAIL_ADDRESS"
										required="true">
								</mat-form-field>
							</div>
						</div>


						<div *ngSwitchCase="'isEdit'" class="row">
							<div class="col-2">
								<button mat-mini-fab color="primary" (click)="updateRow(element)"
									[disabled]="disableSubmit(element)">
									<mat-icon>done</mat-icon>
								</button>
							</div>
							<div class="col-2">
								<button mat-mini-fab (click)="cancelRow(element)">
									<mat-icon class="icon-display">cancel</mat-icon>
								</button>
							</div>
						</div>
					</div>
				</td>
			</ng-container>
			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{'past-row':  !isRowEditable(row)}">
			</tr>
		</table>
		<mat-paginator [length]="dataSource.data.length" [pageSizeOptions]="[2,5, 10, 20]" showFirstLastButtons
			aria-label="Select page of periodic elements">
		</mat-paginator>
	</mat-expansion-panel>
</mat-accordion>